module.exports = __webpack_public_path__ + "img/nav_manageusers.f5c8b543.jpg";